import type { KpiCategory } from "./Kpi"
import type { Kpi } from "./Kpi"

/** Extracts all KPI IDs from a category by flatMapping its groups */
export function getCategoryKpiIds(category: KpiCategory): Array<Kpi["id"]> {
  return category.groups.flatMap((g) => g.kpiIds)
}
